import React from "react";
import TopNavigationBar from "../navigation/TopNavigationBar";

interface UserLayoutProps {
	children: React.ReactNode;
}

const UserLayout: React.FC<UserLayoutProps> = ({ children }) => {
	return (
		<div className="min-h-screen bg-background">
			{/* Top Navigation Bar - No Sidebar */}
			<TopNavigationBar />

		{/* Page Content */}
		<main className="pt-16 lg:pt-20 p-4 sm:p-6 min-h-screen">{children}</main>
		</div>
	);
};

export default UserLayout;
